import axios from "axios";
import store from "~/store";
import * as types from "../mutation-types";
import logger from "~/utilities/logger";

// state
export const state = {
  activity_list: [],
  activity_select: null,
  the_id: null,
  global_activities: [],
};

// getters
export const getters = {
  activity_list: (state) => state.activity_list,
  activity_select: (state) => state.activity_select,
  global_activities: (state) => state.global_activities,
  the_id: (state) => state.the_id,
  check_list: (state) => state.activity_list !== null,
  check_global: (state) => state.global_activities !== null,
};

export const getActivityIndexById = (state, actId) =>
  state.activity_list.findIndex(
    (act) => act.act_id.toString() === actId.toString()
  );
export const getActivityByActId = (state, actId) =>
  state.activity_list.find((act) => act.act_id.toString() === actId.toString());

// mutations
export const mutations = {
  [types.FETCH_ACTIVITIES](state, { activity_list })
  {
    return (state.activity_list = activity_list);
  },

  [types.FETCH_GLOBAL_ACTIVITIES](state, { activity_list })
  {
    // return state.global_activities = activity_list;
  },

  [types.FETCH_ACTIVITIES_BY_OU](state, { activity_list })
  {
    return (state.activity_list = activity_list);
  },

  [types.FETCH_ACTIVITIES_FAILURE](state)
  {
    logger.error("FETCH_ACTIVITIES_FAILURE");
  },

  [types.FETCH_ACTIVITY](state, { activity_select })
  {
    return (state.activity_select = activity_select);
  },

  [types.SELECT_ACTIVITY](state, { act_id })
  {
    // let theAct = getActivityByActId(state, act_id);
    let theAct = state.activity_list.find(
      (act) => act.act_id.toString() === act_id.toString()
    );
    logger.log(theAct);
    return (state.activity_select = theAct);
  },

  [types.DESELECT_ACTIVITY](state)
  {
    return (state.activity_select = null);
  },

  [types.FETCH_ACTIVITY_FAILURE](state, { error })
  {
    logger.error("FETCH_ACTIVITY_FAILURE");
    logger.error(error);
  },

  [types.UPDATE_ACTIVITY](state, { payload })
  {
    // state.activity_select = payload.act_id;
  },

  [types.SET_ACTIVITY_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.DELETE_ACTIVITY](state, { act_id })
  {
    logger.log("store.DELETE_ACTIVITY", state, act_id);
    const index = getActivityIndexById(state, act_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete activity (id ${act_id})`);
    }
    return state.activity_list.splice(index, 1);
  },
};

// actions
export const actions = {
  async getActivities({ commit }, options = {})
  {
    const paginate = options && options.paginate ? options.paginate : 10000;
    const with_status = options?.with_status || null;
    const the_status = options?.the_status || null;
    const extraOptions = options?.extra_options || "";

    logger.log("store.getProjects extraOptions", extraOptions);

    const queryStatus = the_status || with_status || "active";

    const url = `/api/activities?status=${queryStatus}&paginate=${paginate}${extraOptions}`;

    try
    {
      const { data } = await axios.get(url);

      return commit(types.FETCH_ACTIVITIES, {
        activity_list: (data && data?.data?.data) || [],
      });
    } catch (e)
    {
      logger.error("store.getActivities error", e);
      return commit(types.FETCH_ACTIVITIES_FAILURE);
    }
  },

  async getActivitiesByOU({ commit, dispatch }, payload = {})
  {
    const org_id = payload?.org_id || null;

    if (!org_id) return;

    const paginate = payload.paginate || 10000;
    const extraOptions = payload?.extra_options || "";
    // const format = payload?.format || "minimal";

    const url = `/api/activities?org_id=${org_id}&paginate=${paginate}${extraOptions}`;

    try
    {
      logger.log("store.getActivitiesByOU", url);

      const { data } = await axios.get(url);

      logger.log("store.getActivitiesByOU rsp", data && data?.data?.data);

      commit(types.FETCH_ACTIVITIES_BY_OU, {
        activity_list: (data && data.data?.data) || [],
      });
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_ACTIVITIES_FAILURE_BY_OU);
    }
  },

  async selectActivity({ commit, dispatch }, act_id)
  {
    logger.log("store.selectActivity", act_id);

    if (!store.getters["activities/check_list"])
    {
      await store.dispatch("activities/getActivities");
    }

    return commit(types.SELECT_ACTIVITY, { act_id });
  },

  async deselectActivity({ commit, dispatch })
  {
    logger.log("store.deselectActivity");
    return commit(types.DESELECT_ACTIVITY);
  },

  async getActivity({ commit, dispatch }, id)
  {
    try
    {
      const { data } = await axios.get(`/api/activities/${id}`);

      logger.log("store.getActivity rsp", data);

      return commit(types.FETCH_ACTIVITY, {
        activity_select: data && data?.data,
      });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_ACTIVITY_FAILURE, { error: e });
    }
  },

  async deleteActivity({ commit, dispatch }, { act_id })
  {
    try
    {
      const { data } = await axios.delete(`/api/activities/${act_id}`);

      logger.log("store.deleteActivity rsp", data);

      return commit(types.DELETE_ACTIVITY, { act_id });
    } catch (e)
    {
      logger.log(e);
      return commit(types.DELETE_ACTIVITY_FAILURE, { error: e });
    }
  },

  async updateActivity({ commit, dispatch }, payload = {})
  {
    const act_id = payload?.act_id;

    try
    {
      const { data } = await axios.put(`/api/activities/${act_id}`, payload);

      commit(types.UPDATE_ACTIVITY, { payload: data && data?.data });
      logger.log("updateActivity", data);
    } catch (e)
    {
      logger.log(e);
      commit(types.FETCH_ACTIVITY_FAILURE, { error: e });
    }
  },

  setActivityID({ commit, dispatch }, id)
  {
    commit(types.SET_ACTIVITY_ID, { id: id });
  },

  async getLocationWithCountry(sta_location)
  {
    try
    {
      if (!sta_location)
        throw "store.setUserCountryByLocation.locations missing sta_location";

      const { data } = await axios.get(`/api/locations/${sta_location}`);

      logger.log(
        "store.setUserCountryByLocation.locations",
        `/api/locations/${sta_location}`,
        data
      );

      const loc_country_id = data && data?.data?.loc_country_id;

      if (!loc_country_id)
        throw "store.setUserCountryByLocation.locations error";
      // Fetch location

      const locationResponse = await axios.get(
        `/api/locations/${loc_country_id}`
      );

      const countryId = locationResponse?.data?.data?.loc_country_id;

      logger.log("store.setUserCountryByLocation.locations", locationResponse);

      if (!countryId) throw "store.setUserCountryByLocation.locations error";

      // Fetch country
      const countryResponse = await axios.get(`/api/countries/${countryId}`);
      const couID = countryResponse?.data?.data?.cou_id;

      logger.log(
        "store.setUserCountryByLocationgetCountry.country",
        countryResponse
      );

      if (!couID) throw "store.setUserCountryByLocation.locations error";

      logger.log("feeding activities for selectedUser country ", couID);
      return { couID };
    } catch (e)
    {
      logger.error("setUserCountryByLocation error", e);
      return {};
    }
  },

  async getLocation({ uID })
  {
    if (!uID) return;

    await store.dispatch("users/getUser", { usr_id: uID });

    const selectedUser = (await store.getters["users/user_select"]) || null;

    logger.log("activity-feeder SELECTED USER", selectedUser);

    const org_id = selectedUser?.state?.organization?.org_id || null;

    if (!org_id)
    {
      logger.error("SELECTED USER DONT HAVE ORG SET");
    }

    let extra_options = "";
    const { couID } = await actions.getLocationWithCountry(
      selectedUser?.state?.sta_location
    );

    if (couID) extra_options = `&cou_id=${couID}`;

    try
    {
      const body = {
        org_id,
        extra_options,
      };
      logger.log("activities/getActivitiesByOU", body);
      await store.dispatch("activities/getActivitiesByOU", body);
    } catch (e) {}
  },

  async activityFeeder(_, payload)
  {
    const { to = { name: "" } } = payload || {};

    logger.log("activity-feeder to:", payload);

    const config = {
      projects: {
        isProjectIndexPage: true,
        reindex: true,
      },
      "export.add": {
        status: "active-archived",
      },
      "booking.add": {
        reindex: true,
        isBooking: true,
      },
      "organizational_units.user_hours": {
        isUserHours: true, // pm needs all projects on user overview screens; issue #515
      },
      activities: {
        reindex: true,
      },
      "booking.add_for": {
        isBookingFor: true,
      },
    };

    const status = to?.query?.status || "active";
    const uID = to?.params?.uid || null;

    const filters = {
      format: "minimal",
      paginate: 10000,
      isBooking: false,
      isBookingFor: false,
      reindex: false,
      isPM: false,
      extraExcl: "",
      isProjectIndexPage: false,
      uID,
      status,

      // Attach options for specific name
      ...(config?.[to?.name] || {}),
    };

    const isAuthorized = await store.getters["auth/check"];

    let userObj = null;

    if (isAuthorized)
    {
      userObj = await store.getters["auth/user"];
    }

    // Required

    await actions.getLocation(filters);

    // (!getters["activities/check_list"] || reindex) - old
    if (!store.getters["activities/check_list"] && !filters?.reindex) return;

    if (filters?.isBooking)
    {
      if (!userObj) return;

      const org_id = userObj?.state?.organization?.org_id;

      logger.log("activities/getActivitiesByOU", org_id);

      await store.dispatch("activities/getActivitiesByOU", { org_id });
      return;
    }

    if (!filters.isBookingFor)
    {
      await store.dispatch("activities/getActivities");
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
